/**
 * 
 * Lead Header
 * 
 */


 import React, {  } from 'react'
 import PropTypes from 'prop-types'
 import MetaTags from 'react-meta-tags'
 import {
     Container,
     Row,
     Col,
     Button,
 } from "reactstrap"
 
 import { useHistory } from 'react-router-dom'
 //Import Breadcrumb
 import Breadcrumbs from "../../../components/Common/Breadcrumb"
 
 
 function EmployeeHeader() {
     const history = useHistory()
 
     return (
         <React.Fragment>
             <div>
                 <MetaTags>
                     <title>Manage Employee</title>
                 </MetaTags>
                 <Container fluid>
                     {/* Render Breadcrumb */}
                     <Breadcrumbs
                         title={'HRMS'}
                         breadcrumbItem={'Manage Employee'}
                     />
 
                     <Row style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', marginBottom: '12px' }}>
                         <Col style={{ flex: '1 2', display: 'flex', justifyContent: 'flex-end' }}>
                             <Button
                                 id="add-lead-btn"
                                 onClick={() => { history.push({ pathname: '/create-employee' })} }
                                 color="primary">
                                 {`Add Employee`}
                             </Button>
                         </Col>
                     </Row>
 
 
                 </Container>
             </div>
         </React.Fragment>
     )
 
 }
 
 EmployeeHeader.propTypes = {
     t: PropTypes.any,
     columns: PropTypes.func,
     title: PropTypes.string,
     actions: PropTypes.object,
     access: PropTypes.array,
     metaData: PropTypes.object,
     loading: PropTypes.any,
     // flagAddBtn: PropTypes.any,
     formTitle: PropTypes.string,
     onSubmitValues: PropTypes.func
 }
 
 export default EmployeeHeader
 